

export interface Agent {
	code: string;
	name: string;
	description?: string;
}

export enum AGENTS_CODE {
	PLANNER = "planner_advisor",
	AGRO = "agro_qa_agent",
	SUPPORT = "zero_support",
	BI = "bi_advisor"
} 

// AGENT OPTIONS
export const ZeroGPTAgents: Agent[] = [
	{
		code: AGENTS_CODE.PLANNER, 
		name: 'PLANNER' 
	},
	{ 
		code: AGENTS_CODE.AGRO, 
		name: 'AGRICULTURE Q&A' 
	},
	{ 
		code: AGENTS_CODE.SUPPORT, 
		name: 'ZERO SUPPORT' 
	},
	{ 
		code: AGENTS_CODE.BI, 
		name: 'BI ADVISOR' 
	}
]
